import { createModel } from '@rematch/core';
import { providersService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';
import { CoachAssignmentNode } from 'src/generated/webapp_gql';
import { FetchStatus } from 'src/shared/models/shared';

export interface ProvidersState {
    myProviders: CoachAssignmentNode[] | null;
    fetchStatus: FetchStatus;
}

const defaultState: ProvidersState = {
    myProviders: null,
    fetchStatus: FetchStatus.NotStarted,
};

export const providers = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        addMyProviders: (state, payload: CoachAssignmentNode[]): ProvidersState => {
            state.myProviders = payload;
            state.fetchStatus = FetchStatus.Completed;

            return state;
        },
        'authentication/onLogout': (): ProvidersState => {
            return defaultState;
        },
    },
    effects: () => ({
        /**
         * @deprecated Use `refetchQueries` or another apollo-client option to re-fetch the
         * user's providers.
         */
        async fetchMyProviders(_payload: void): Promise<void> {
            await providersService.fetchMyProviders();
        },
    }),
});
